import { Component } from '@angular/core';
import { StorageService } from '../../../../services/StorageService';
import { VenueService } from '../../../../services/VenueService';
import { Apiservice } from '../../../../services/ApiService';
import { PermissionsService } from '../../../../services/Permissions';
import { Router } from '@angular/router';

@Component({
  selector: 'app-barcode-history',
  templateUrl: './barcode-history.component.html',
  styleUrl: './barcode-history.component.scss'
})
export class BarcodeHistoryComponent {
  Selectedvenue: string = '';
  venuelist: any[] = [];
  venueValue: string = '';
  barcode: string = '';
  historySummary: any = [];
  loading: boolean = false;
  isTicketmaster: boolean = false;

  constructor(private storage: StorageService, private router: Router, public venue: VenueService, private apiservice: Apiservice, private permissions: PermissionsService) {
    this.permissions.ticketmaster.subscribe(val => this.isTicketmaster = val);
  }


   getVenueList(){
    this.loading = true;
    this.venue.getVenueList().subscribe((data:any) => {
      this.venuelist = data;
      this.loading = false;
    });
  }

  onVenueChange(){
    this.storage.saveVenue(this.Selectedvenue);
    const selectedVenueObj = this.venuelist.find(venue => venue.key === this.Selectedvenue);
    this.venueValue = selectedVenueObj ? selectedVenueObj.value: '';
  }

  onBarcodeChange(event: any){
    this.barcode = event?.target?.value;
  }

  getBarcodeHistory(event: any) {

    this.apiservice
      .getHistory(this.Selectedvenue, this.barcode)
      .subscribe((result: any) => {
        this.historySummary = result;
      });
  }

  ngOnInit(): void {
    this.getVenueList();
    const savedVenue = this.storage.getVenue();
    if (savedVenue) {
      this.Selectedvenue = savedVenue;
    }
  }


}
